<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        Create Construct
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">Create New Construct</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name*"
                  :rules="[(v) => !!v || 'Name is required.']"
                  v-model="constructDetails.name"
                  required
                  hint="Please use title case (e.g., Decision Making)."
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="constructDetails.construct_type_id"
                  :items="constructTypeMap"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.construct_type_id"
                  :rules="[(v) => !!v || 'You must select a construct framework.']"
                  label="Construct Framework*"
                  hint="Select which construct framework the construct will belong to."
                  persistent-hint
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="constructDetails.parent_construct_id"
                  :items="getRelevantParentConstructs()"
                  :item-text="(construct) => construct.name"
                  :item-value="(construct) => construct.id"
                  label="Parent Construct"
                  hint="Select the parent construct. Leave blank if the construct has no parent."
                  persistent-hint
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  label="Definition"
                  hint="Definition of the construct."
                  v-model="constructDetails.definition"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  label="Is Observable"
                  hint="Is the construct observable."
                  v-model="constructDetails.is_observable"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
        <v-btn :disabled="!valid" color="primary" text @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Bus } from '@/bus'

export default {
  name: 'ConstructDialog',
  props: {
    constructs: Array,
    constructTypeMap: Array
  },
  data () {
    return {
      valid: true,
      dialog: false,
      constructDetails: {
        is_observable: false
      },
      childConstructs: [],
      version: '0.1.0'
    }
  },
  methods: {
    save () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        try {
          this.$store.dispatch('bcm/createConstruct', this.constructDetails)
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to create Construct in Blueprint Content Manager'
          })
        } finally {
          this.$emit('constructSaved')
          this.constructDetails = {}
          this.$refs.form.reset()
          this.dialog = false
        }
      }
    },
    getRelevantParentConstructs () {
      return this.constructs.filter(construct => parseInt(construct.construct_type_id) === parseInt(this.constructDetails.construct_type_id))
    }
  }
}
</script>
